import { render, staticRenderFns } from "./MultiCourseForm.vue?vue&type=template&id=df015ba6&lang=pug"
import script from "./MultiCourseForm.vue?vue&type=script&lang=js"
export * from "./MultiCourseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports